<template>
  <div
    :class="[$style.base, { [$style.completed]: completed }]"
    @click="$emit('selection', field)"
  >
    <BaseCard>
      <Flex direction="column">
        <BaseRadio
          v-if="!completed"
          :modelValue="index === columnIndex && selected"
          :options="[{ label: field, value: field }]"
        />
        <div
          v-if="completed"
          :class="$style.checkmarkCompleted"
        >
          <div :class="$style.checkmark">
            <BaseIcon
              name="checkmark"
              size="s"
              color="inverted"
            />
          </div>
          <BaseText>{{ field }}</BaseText>
        </div>
        <div :class="$style.columns">
          <div
            v-for="(item, idx) in options"
            :key="item"
            :class="[
              $style.text,
              {
                [$style.odd]: idx % 2
              }
            ]"
          >
            <BaseText oneLine>{{ item }}</BaseText>
          </div>
        </div>
      </Flex>
    </BaseCard>
  </div>
</template>

<script
  lang="ts"
  setup
>
defineProps<{
  options: string[];
  field: string;
  selected: string;
  completed: boolean;
  index: number;
  columnIndex: number;
}>();
defineEmits(['selection']);
</script>

<style
  lang="scss"
  module
>
.base {
  width: 270px;
  cursor: pointer;

  &.completed {
    cursor: not-allowed;
  }
}

.checkmarkCompleted {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
}

.checkmark {
  height: 18px;
  width: 18px;
  border-radius: 100%;
  background-color: var(--color-success);

  display: flex;
  align-items: center;
  justify-content: center;
}

.columns {
  display: column;
}

.text {
  padding: $spacing;
  background-color: var(--color-bg-secondary);
  border-bottom: var(--color-border) 1px solid;
  min-height: 50px;

  &.odd {
    background-color: var(--color-bg);
  }
}
</style>
